import { gql } from '@apollo/client';

const TaskCommenter = gql`
	  fragment TaskCommenter on TaskCommenterDTO {
    #__typename # TaskCommenter:ProjectUser

    userId
    username
    firstname
    lastname
    avatar
  }
`;

export default TaskCommenter;
